module.exports = __webpack_public_path__ + "static/media/error_icon.b15a4419.svg";